<template>
  <article class="page-offline-top10">
    <!-- chart panel -->
    <crm-panel class="chart-panel">
      <!-- total time -->
      <section class="tips-container">
        <span class="tips-container_text">数据统计于{{ totalTime }}</span>
      </section>
      <!-- toolbar -->
      <section class="select-container">
        <el-form :inline="true">
          <span class="select-container_label">电话咨询统计</span>
          <el-form-item>
            <el-date-picker
              v-model="searchYear"
              :clearable="false"
              type="year"
              placeholder="选择年"
              @change="handleTimeRangeChange"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="select-container_buttons">
          <crm-button
            v-if="
              auth.adTelStatisticsDownload &&
              auth.adTelStatisticsDownload.toggleStatus
            "
            buttonType="plain"
            text="导出"
            @click="handleExport()"
          >
          </crm-button>
        </div>
      </section>
      <!-- total block -->
      <section class="total-container">
        <div
          class="total-container_block"
          v-for="totalBlock in totalBlockList"
          :key="totalBlock.tipText"
        >
          <crm-block v-bind="totalBlock" />
        </div>
      </section>
      <!-- chart -->
      <section class="chart-container" />
    </crm-panel>

    <!-- table panel -->
    <crm-panel class="table-panel">
      <!-- table -->
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column prop="monthDate" label="月份" align="center">
        </el-table-column>
        <el-table-column prop="delivery" label="送达量" align="center">
        </el-table-column>
        <el-table-column prop="pickUp" label="接起量" align="center">
        </el-table-column>
        <el-table-column prop="deliveryRate" label="送达率" align="center">
          <template slot-scope="{ row }">
            <span>{{
              `${((Number(row.pickUp) / Number(row.delivery)) * 100).toFixed(
                2,
              )}%`
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </crm-panel>
  </article>
</template>

<script>
import moment from 'moment';
import * as echarts from 'echarts/echarts.common';
import { mapActions, mapGetters } from 'vuex';
import { serviceCount } from 'crm-common';

import { conversion, downloadByUrl } from '@/scripts/utils';
import http from '~services/axios';
import CHART_TOTAL_BLOCK_PROPS from '~services/constant/statistics/service-total-block';
import CHART_API_CONFIG from '~api/statistics/service-api-config';
import getTimeRangeByAlias from '~services/time-range';

import ChartTotalTimeOptions from '@/components/business/datastatistics/chart-total-time-options';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import CrmBlock from '@/components/base/crmBlock';

const { apiFactory, totalFactory, chartFactory: optionFactory } = serviceCount;
const diagramCommonApi = apiFactory(http, CHART_API_CONFIG);

// crm-common包中对每个图表定义的名称
const CHART_NAME = 'phone';

/**
 * TABLE_GETTER_NAME: vuex-store里对应的表格数据getter名称
 * TABLE_ACTION_NAME: vuex-store里对应的表格数据获取action名称
 *  */
const TABLE_GETTER_NAME = 'telCounselingTableData';
const TABLE_ACTION_NAME = 'getTelCounselingTableData';

// echarts instance
let chart;
const echartsConfig = {
  devicePixelRatio: window.devicePixelRatio,
};
const defaultDataFormat = 'YYYY-MM-DD';

export default {
  components: {
    CrmPanel,
    CrmButton,
    CrmBlock,
    ChartTotalTimeOptions,
  },
  filters: {
    conversion,
  },
  data() {
    const yestoday = moment()
      .dates(moment().date() - 1)
      .format(defaultDataFormat);

    return {
      loading: false,
      totalTime: yestoday,
      timeRangeAlias: 'this-month',
      searchYear: moment().format('YYYY'),
      totalBlockList: [],
      tableData: [],
      chartSearchForm: {
        startDate: moment()
          .startOf('year')
          .format(defaultDataFormat),
        endDate: moment()
          .endOf('year')
          .format(defaultDataFormat),
      },
    };
  },
  computed: {
    ...mapGetters('authority', {
      auth: 'auth',
    }),
  },
  mounted() {
    const chartContaiter = document.querySelector('.chart-container');
    chart = echarts.init(chartContaiter, 'light', echartsConfig);
    this.getDiagram();
  },
  methods: {
    renderTotalTime() {
      this.totalTime = moment()
        .dates(moment().date() - 1)
        .format(defaultDataFormat);
    },
    handleTimeRangeChange(value) {
      this.chartSearchForm = {
        startDate: moment(value)
          .startOf('year')
          .format(defaultDataFormat),
        endDate: moment(value)
          .endOf('year')
          .format(defaultDataFormat),
      };
      this.getDiagram();
    },
    renderTotalBlock(data) {
      // total: [{ key: 'totalOrder', value: 100, alias: '总订单量' }, {}, ...]
      const total = totalFactory(CHART_NAME, data);
      this.totalBlockList = total.map(({ key, value }) => {
        const totalComponentProps = CHART_TOTAL_BLOCK_PROPS[key];
        totalComponentProps.theme = value;
        return totalComponentProps;
      });
    },
    renderChart(data) {
      const option = optionFactory(CHART_NAME, data);
      chart.setOption(option);
    },
    renderTable(data) {
      this.tableData = data;
      this.handleTableData();
    },
    // chart ajax
    getDiagram() {
      diagramCommonApi(CHART_NAME, this.chartSearchForm).then((res) => {
        const {
          results,
          totalDelivery,
          totalPickUp,
          totalDeliveryRate,
        } = res.data;
        this.renderTotalTime();
        this.renderTotalBlock({
          totalDelivery,
          totalPickUp,
          totalDeliveryRate,
        });
        this.renderChart(results);
        this.renderTable(results);
      });
    },
    handleTableData() {
      this.tableData.forEach((item) => {
        const rateNum = (
          (Number(item.pickUp) / Number(item.delivery))
          * 100
        ).toFixed(2);
        item.deliveryRate = `${rateNum}%`;
      });
    },
    handleExport() {
      const params = this.chartSearchForm;
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在导出中，请稍后...',
        duration: 0,
        showClose: false,
      });

      let url = '/api/serviceData/download/telephoneStatistics?';
      Object.keys(params).forEach((item) => {
        if (params[item]) url += `${item}=${params[item]}&`;
      });

      downloadByUrl(url);
      if (this.notify) this.notify.close();
    },
  },
};
</script>

<style lang="less" scoped>
.page-offline-top10 {
  width: 100%;

  // 图表面板
  .chart-panel {
    padding: 0;
    .tips-container {
      background: rgba(240, 183, 98, 0.1);
      height: 28px;
      line-height: 28px;
      &_text {
        padding-left: 20px;
        color: #7a84b7;
      }
    }
    .select-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      &_label {
        line-height: 42px;
        font-size: 24px;
        color: #7a84b7;
        padding-right: 30px;
      }
    }
    .total-container {
      display: flex;
      flex-wrap: wrap;
      &_block {
        margin-left: 20px;
        margin-bottom: 20px;
      }
    }
    .chart-container {
      margin: 0 20px 20px 20px;
      height: 220px;
    }
  }

  // 表格面板
  .table-panel {
    margin-top: 20px;
    height: 400px;
  }
}
</style>
